"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.RightArrow = exports.LeftArrow = exports.CategorySelector = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LexusTypography = require("../LexusTypography");
var _ToyotaTypography = require("../ToyotaTypography");
var _breakpoints = require("../breakpoints");
const LeftArrow = exports.LeftArrow = _styledComponents.default.button`
  border: none;
  padding: 0;
  background: none;
  transform: rotate(90deg);
  cursor: pointer;
  display: block;

  svg {
    fill: #000;
    height: 10px;
  }
  &[disabled] svg {
    fill: #d8d8d8;
    cursor: not-allowed;
  }
`;
const RightArrow = exports.RightArrow = (0, _styledComponents.default)(LeftArrow)`
  transform: rotate(-90deg);
`;
const CategorySelector = exports.CategorySelector = _styledComponents.default.div`
  display: block;
  text-align: center;
  white-space: nowrap;
  position: relative;
  overflow-x: auto;

  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    border-bottom: 2px solid #d8d8d8;
    &.stuck{
      padding-bottom: 10px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  a {
    margin: 0 5px;
    text-decoration: none;
    display: inline-block;
    position: relative;
    padding: 20px 5px 8px;
    &:hover {
      color: inherit;
    }

    ${(0, _breakpoints.breakpoint)("desktop", "up")} {
      margin: 0 23px;
      padding: 20px 5px 8px;
    }
  }

  .active {
    &:after {
      content: '';
      width: 100%;
      height: 2px;
      background: #000;
      position: absolute;
      display: block;
      bottom: 0;
      ${(0, _breakpoints.breakpoint)("desktop", "up")} {
        bottom: -2px;
      }
      left: 0;
      z-index: 1;
    }
  }
`;
const Wrapper = exports.Wrapper = _styledComponents.default.div`
  display: flex;
  width: 100%;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 40px;
  background: #FFF;
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  margin-left: -20px;
  padding: 0 20px;
  ${(0, _breakpoints.breakpoint)("desktop", "up")} {
    padding: 0;
    margin-left: -20px;
    top: -1px;
    width: calc(100% + 40px);
  }
  ${(0, _breakpoints.breakpoint)("tablet", "down")} {
    ${function (_ref) {
  let {
    theme
  } = _ref;
  return theme === "Lexus" ? `
    ` : `
      box-sizing: content-box;
    `;
}}
  }
  ${function (_ref2) {
  let {
    theme
  } = _ref2;
  return theme === "Lexus" ? `
      a {
        ${(0, _LexusTypography.nobel)({
    sizing: "body14"
  })}
      }
      .active {
        ${(0, _LexusTypography.nobel)({
    sizing: "body14",
    weight: "bold"
  })}
      }
    ` : `
      a {
        ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "input01"
  })}
      }
      a:hover, .active, a:focus-visible {
        outline: 0;
        ${(0, _ToyotaTypography.ToyotaType)({
    sizing: "input01",
    weight: "semibold"
  })}
      }
    `;
}}
`;